import $ from 'jquery';

const reOrder = function () {

    if ($('.gform_wrapper').length > 0) {

        if ($('.left-col').length > 0 && $('.right-col').length > 0) {

            $('.left-col').parent().addClass('ignore');
            $('.right-col').parent().addClass('ignore');

            jQuery('.gf_left_half:not(.ignore)').each(function (index) {

                let id = jQuery(this).attr('id');
                if (!index > 1) {
                    jQuery("#" + id).prependTo('.placeholder[data-placeholder="' + id + '"]');
                }
            });

            jQuery('.gf_right_half:not(.ignore)').each(function (index) {

                let id = jQuery(this).attr('id');
                if (!index > 1) {
                    jQuery("#" + id).prependTo('.placeholder[data-placeholder="' + id + '"]');
                }


            });

        }
    }

};

export default reOrder;
